import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useScrollTo } from "./SmoothScroll";

const WORDS = ["Business Websites", "E-Commerce", "Clinics & Hospitals", "Salons & Spas", "Restaurants & Cafes", "Real Estate", "Education", "Landing Pages", "Redesigns", "Maintenance"];

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-6 w-6 shrink-0 text-[var(--gold)] sm:mx-12 sm:h-8 sm:w-8" aria-hidden="true">
    <path fill="currentColor" d="M12 0l2.4 9.6L24 12l-9.6 2.4L12 24l-2.4-9.6L0 12l9.6-2.4z" />
  </svg>
);

export const Marquee = () => (
  <section aria-label="Industries we design for" data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 py-10 sm:py-14">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`font-display whitespace-nowrap text-4xl font-medium tracking-tight sm:text-6xl lg:text-7xl ${i % 2 ? "italic text-transparent [-webkit-text-stroke:1px_rgba(246,217,139,.7)]" : "text-white"}`}>{w}</span>
              <Star />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export const PromoBanner = () => {
  const scrollTo = useScrollTo();
  return (
    <section data-testid="promo-banner" className="px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 overflow-hidden rounded-3xl border border-gold/30 bg-gradient-to-r from-[#1a1606] via-[#0f1a36] to-[#0a1226] px-6 py-8 sm:px-10 md:flex-row md:items-center"
      >
        <div className="pointer-events-none absolute -left-20 top-1/2 h-60 w-60 -translate-y-1/2 rounded-full bg-gold/20 blur-3xl" />
        <p className="font-display relative text-xl font-medium leading-snug text-white sm:text-2xl lg:text-3xl">
          <span className="text-gold-grad">Premium Website Designs.</span> Affordable Prices. <span className="italic text-slate-300">Unlimited Possibilities.</span>
        </p>
        <a href="/#contact" onClick={(e) => scrollTo("contact", e)} data-testid="promo-banner-cta" className="relative inline-flex shrink-0 items-center gap-2 rounded-full border border-gold/60 px-6 py-3 text-sm font-semibold text-[var(--gold-2)] transition-[background-color,color] duration-300 hover:bg-[var(--gold)] hover:text-black">
          Start your project <ArrowRight className="h-4 w-4" />
        </a>
      </motion.div>
    </section>
  );
};
